/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brave_Noble_Meerkat_EmbraceInputs */

const en_brave_noble_meerkat_embrace = /** @type {(inputs: Brave_Noble_Meerkat_EmbraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect`)
};

/**
* | output |
* | --- |
* | "Connect" |
*
* @param {Brave_Noble_Meerkat_EmbraceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const brave_noble_meerkat_embrace = /** @type {((inputs?: Brave_Noble_Meerkat_EmbraceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brave_Noble_Meerkat_EmbraceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_brave_noble_meerkat_embrace(inputs)
});